import { render, staticRenderFns } from "./StudentChatbot.vue?vue&type=template&id=25948d20&scoped=true&"
import script from "./StudentChatbot.vue?vue&type=script&lang=js&"
export * from "./StudentChatbot.vue?vue&type=script&lang=js&"
import style0 from "./StudentChatbot.vue?vue&type=style&index=0&id=25948d20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25948d20",
  null
  
)

export default component.exports